import { aquireSession } from "./session.js";
import { ICONS, mountShell, userFromToken } from "./shell.js";

async function main() {
    const StateP = import("./state.js").then((m) => m.State);
    const token_id = await aquireSession();
    const listP = import("./list.js").then((m) => m.InstList);
    const serverP = import("./servers.js").then((m) => m.ServerList);
    const monitorP = import("./monitor.js").then((m) => m.MonitorView);
    const State = await StateP;
    const stateP = State.create(token_id);
    const InstList = await listP;
    const ServerList = await serverP;
    const MonitorView = await monitorP;
    const list = new InstList();
    const servers = new ServerList();
    const monitor = new MonitorView();

    mountShell(
        [
            {
                id: "servers",
                label: "Servers",
                icon: ICONS.servers,
                element: servers,
            },
            {
                id: "instances",
                label: "Instances",
                icon: ICONS.instances,
                element: list,
            },
            {
                id: "monitor",
                label: "Monitor",
                icon: ICONS.monitor,
                element: monitor,
            },
        ],
        userFromToken(token_id)
    );

    const state = await stateP;
    list.instState = state;
    servers.state = state;
    monitor.state = state;
}

main().catch((e) => console.error(e));
